module.exports = __webpack_public_path__ + "media/01_shirakumono_youran_karatiribamete_haitukubau_seitenno_moto_fukasu_ashi.555938e7.mp3";